<template>
  <grid :config="{searchFields: ['name']}" :data="teams">
    <template v-slot:gridAdd>
      <sceRouteButton :route="{ name: 'event.clubs.teams.add'}" label="team.add"
                      class="c-button--secondary c-button--large" icon="svg-symbols.svg#plus-icon" />
    </template>
    <template v-slot:gridHeader>
      <div class="o-layout c-list__row u-padding-horizontal-small">
        <div class="o-layout__item u-4-of-5-at-medium">
          {{$t('name')}}
        </div>
        <div class="o-layout__item u-1-of-5-at-medium">
          {{$t('members.count')}}
        </div>
      </div>
    </template>
    <template v-slot:gridData="{element}">
      <div class="o-layout__item u-4-of-5-at-medium c-list__main-cell">
        <router-link class="c-list__link"
                     :to="{ name: 'event.clubs.teams.view', params: { teamId: element.id}}">
          {{element.name}}
        </router-link>
      </div>
      <div class="o-layout__item u-1-of-5-at-medium">
        {{element.members.length}}
      </div>
    </template>
  </grid>
</template>

<script>
  import filter from 'lodash/filter'
  import sortBy from 'lodash/sortBy'

  export default {
    name:'teams-list',
    components: {
      grid: require('client/components/dataGrid.vue').default,
    },
    computed: {
      teams: function() {
        return sortBy(filter(this.$store.state.teams.items, item => item.clubId === this.$route.params.clubId), 'name')
      }
    },
    methods: {
    }
  };
</script>

<style>
</style>
